<!--
  * @Author: changyunxia
  * @Date:2020年10月14日 16:42:25
  * @LastEditors: changyunxia
  * @LastEditTime: @Date:2020年10月14日 16:42:25
  * @Description: 获取所有员工
  * @FilePath:@/components/MeetingReservation/MeetGetUser.vue
-->
<template>
  <div>
    <van-field
      readonly
      clickable
      :label="label"
      :name="name"
      :value="value"
      :right-icon="rightIcon"
      @click="showPicker = true"
    />
    <van-popup v-model="showPicker" position="bottom" style="height:100vh">
      <MeetingUser :show-picker.sync="showPicker" :list="list" @getUserName="getUserNameFunc" />
    </van-popup>
  </div>
</template>

<script>
import MeetingUser from '@/components/MeetingReservation/MeetingUser'
import { GetUserList, GetDeptList } from '@/api/Meeting'
export default {
  name: 'MeetGetUser',
  components: { MeetingUser },
  props: {
    label: {
      type: String,
      default: null
    },
    name: {
      type: String,
      default: null
    },
    defaultValue: {
      type: String,
      default: null
    },
    rightIcon: {
      type: String,
      default: null
    },
    list: {
      type: Array,
      default: null
    }
  },
  data() {
    return {
      value: this.defaultValue,
      showPicker: false
      // list: []
    }
  },
  computed: {},
  watch: {
    defaultValue(nVal) {
      this.value = nVal
    }
  },
  created() {
    // this.getUserList()
  },
  mounted() {

  },
  methods: {
    getUserList() {
      var _this = this
      GetUserList({ user_code: '2008001' }, function(res) {
        _this.list = res.data
      })
      GetDeptList({ department: '0000000000' }, function(res) {
        console.log(res)
      })
    },
    getUserNameFunc(data) {
      this.showPicker = false
      this.value = data.text
    }
  }
}
</script>
<style lang='scss' scoped>

</style>
